import { Button, Text, Tooltip } from '@components'
import type { Component, JSXElement } from 'solid-js'
import { Portal } from 'solid-js/web'
import { Box } from 'styled-system/jsx'

const Action: Component<{
	heading: string
	text: string
	active?: boolean
	disabled?: boolean
	onClick: () => void
	icon: JSXElement
	loading?: boolean
}> = (props) => {
	return (
		<Tooltip.Root>
			<Tooltip.Trigger>
				<Button
					loading={props.loading}
					colorPalette={props.active ? 'tscGreen' : 'gray'}
					disabled={props.disabled}
					variant="outline"
					size="xs"
					onClick={props.onClick}
				>
					<Box
						display={{
							base: 'inline-flex',
							mdDown: 'none',
						}}
					>
						{props.heading}
					</Box>
					{props.icon}
				</Button>
			</Tooltip.Trigger>
			<Portal>
				<Tooltip.Positioner>
					<Tooltip.Arrow>
						<Tooltip.ArrowTip />
					</Tooltip.Arrow>
					<Tooltip.Content>
						<Text>{props.text}</Text>
					</Tooltip.Content>
				</Tooltip.Positioner>
			</Portal>
		</Tooltip.Root>
	)
}

export default Action
